import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TabService {
    private _tabs$ = new BehaviorSubject<any[]>([]);
    private _activeTab$ = new BehaviorSubject<string>('');

    tabs$ = this._tabs$.asObservable();
    activeTab$ = this._activeTab$.asObservable();

    get tabs(): any[] {
        return this._tabs$.value;
    }

    get activeTab(): string {
        return this._activeTab$.value;
    }

    constructor() { }

    openTab(item: any) {
        this._activeTab$.next(item.menuCd);
        const exists = this.tabs?.find(t => t.menuCd === item.menuCd);
        if (!exists) {
            const newTabs = [...this.tabs, item];
            this._tabs$.next(newTabs);
        }
        else {
            this._tabs$.next(this.tabs);
        }
    }

    closeTab(menuCd: string) {
        const updatedTabs = this.tabs.filter(t => t.menuCd !== menuCd);
        this._tabs$.next(updatedTabs);

        if (this.activeTab === menuCd) {
            const nextTab = updatedTabs[updatedTabs.length - 1];
            this._activeTab$.next(nextTab?.menuCd || '');
        }
    }

    closeAllTab() {
        const updatedTabs: any[] = [];
        this._tabs$.next(updatedTabs);

        this._activeTab$.next('dashboard');
    }

    setActive(menuCd: string) {
        this._activeTab$.next(menuCd);
    }
}
